import { Flex, Radios, Text } from "src/elements";

interface Props<T> {
  title: string;
  options: Array<{ label: string; value: T; isDisabled?: boolean }>;
  value: T;
  setValue: (value: T) => void;
  isDisabled?: boolean;
  direction?: "column";
}

export const RuleRadios = <T,>({
  title,
  options,
  value,
  setValue,
  isDisabled,
  direction,
}: Props<T>) => {
  return (
    <Flex column justify="center" padding="10px" gap="10px">
      <Text variant="small1" textAlign="center" isDisabled={isDisabled}>
        {title}
      </Text>

      <Radios
        width="auto"
        options={options}
        value={value}
        setValue={setValue}
        isDisabled={isDisabled}
        direction={direction}
      />
    </Flex>
  );
};
